import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import StyledToolTip from '../../../../common/StyledToolTip';
import MoneyOffWithOutline from '../../../../../layout/icons/MoneyOffWithOutline';
import { withStyles } from '@material-ui/core';
const getShipmentProperties = (shipmentDetails) => [
    { label: "Pros", value: shipmentDetails.totalProps },
    { label: "Priority", value: shipmentDetails.priority },
    { label: "HU", value: shipmentDetails.hu },
    { label: "Special Needs", value: shipmentDetails.specialNeeds },
    { label: "Weight", value: shipmentDetails.totalWeight },
    { label: "PSE", value: shipmentDetails.pse },
    { label: "No. Of Stops", value: shipmentDetails.totalStops },
  ];

  const Default_Shipment_Properties = {
    shipments: [],
    pros: 0,
    hu: 0,
    priority: 0,
    specialNeeds: 0,
    weight: 0,
    pse: 0,
    totalStops: 0,
  };
const styles = (theme) => ({
  holdProIcon: { display: 'flex', paddingRight: 4 }
});
const holdProIcon = ({shipment, classes}) => {
  if (shipment.isOnHoldRM) {
    return (
      <StyledToolTip title="Pro is on hold (RouteMax)">
        <div className={classes.holdProIcon}>
          <MoneyOffWithOutline color="#9E0000" />
        </div>
      </StyledToolTip>
    );
  }
  return (
    <StyledToolTip title="Pro is on hold">
      <MoneyOffIcon />
    </StyledToolTip>
  );
};
const HoldProIconWithStyles = withStyles(styles)(holdProIcon);

const getLassoBadgeLabel = (shipment) => {
  return (
    <>
      {shipment.isOnHold && (
        <HoldProIconWithStyles shipment={shipment} />
      )}
      {shipment.isDelivery ? shipment.displayCustomerName : shipment.shipperName}      
    </>
  );
};

export { Default_Shipment_Properties, getShipmentProperties, getLassoBadgeLabel };
